// extracted by mini-css-extract-plugin
export default {"snackbar-content":"Toast_snackbar-content__ewPJv"};